/**
 * Which deal-table fields the current user may edit inline (REG-739). One
 * place for every grid, mirroring the database rules so a grid never offers an
 * editor that the write would then reject:
 *
 * - supabase/pg/rbac/deal_rls.sql: merchant, submission and rep_link writes
 *   need `edit_deals`; without it, merchant_rbac_column_guard() lets a rep
 *   change only the notes / additional-contact columns below on their own
 *   merchants.
 * - supabase/pg/rbac/public_write_lockdown.sql: every other public business
 *   table (rep, funder, lead_source, ...) updates with `edit_deals`.
 *
 * Capabilities come from the user's groups, so moving `edit_deals` between
 * roles in the admin UI moves the editors with it. The database stays the
 * authorization boundary; this only decides what the grid offers.
 */
const LIMITED_MERCHANT_FIELDS = new Set([
  'note',
  'alternate_phone',
  'alternate_phone2',
  'alternative_email',
  'ContactMethod',
]);

const DEAL_TABLES = new Set(['merchant', 'submission', 'rep_link', 'rep', 'funder', 'lead_source']);

export function canEditDealField(
  tableName: string,
  fieldName: string,
  hasCapability: (key: string) => boolean,
): boolean {
  if (!DEAL_TABLES.has(tableName)) return true;
  if (hasCapability('edit_deals')) return true;
  return tableName === 'merchant' && LIMITED_MERCHANT_FIELDS.has(fieldName);
}
